import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-four-o-four',
  templateUrl: './error-four-o-four.component.html',
  styleUrls: ['./error-four-o-four.component.scss']
})
export class ErrorFourOFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
